import React from 'react';

export interface IPaymentPortalFooter {
  websiteLink?: string;
  websiteText?: string;
  bgColor?: string;
}

const PaymentPortalFooter: React.FC<IPaymentPortalFooter> = ({ websiteLink, websiteText, bgColor }) => (
  <footer className="payment-portal-home__footer" style={{ backgroundColor: bgColor }}>
    <a href={websiteLink}>{websiteText}</a>
  </footer>
);

export default PaymentPortalFooter;
